// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IWolfEnvironment } from '@advania-cosoftware/wolf-core';

export const environment: IWolfEnvironment = {
    /** {@inheritdoc IWolfEnvironment} */
    envName: 'Development',

    /** {@inheritdoc IWolfEnvironment} */
    production: false,

    /** {@inheritdoc IWolfEnvironment} */
    buildVersion: '2.0.0.345-Drop', // Leave as is - will be updated by build-process

    /** {@inheritdoc IWolfEnvironment} */
    serviceNowUrl: 'https://visolit.service-now.com/support',

    /** {@inheritdoc IWolfEnvironment} */
    enableLog: false, // If true the LogService will log information

    /** {@inheritdoc IWolfEnvironment} */
    instrumentationKey: '4685794a-44b5-414b-82a1-d05dd0193242',

    /** {@inheritdoc IWolfEnvironment} */
    getOpus3ApiBaseUrl(): string {
        return window.location.origin + '/api/opus-3-api';
    },

    /** {@inheritdoc IWolfEnvironment} */
    getOpusWebApiBaseUrl(): string {
        return window.location.origin + '/api/opus-web-api';
    },

    getOpusApiBaseUrl(): string {
        return window.location.origin + '/api/opus-api';
    },
};
